// Amplía únicamente las etiquetas de los el-select multiple con collapse-tags.
// :max-collapse-tags="3" permite variar el límite; por defecto se muestran dos.
export default {
  install(Vue) {
    Vue.component("ElSelect").mixin({
      props: {
        maxCollapseTags: {
          type: Number,
          default: 2,
          validator: value => Number.isInteger(value) && value > 0,
        },
      },
      beforeCreate() {
        const render = this.$options.render;

        this.$options.render = function(createElement) {
          const root = render.call(this, createElement);
          if (!this.multiple || !this.collapseTags || !this.selected.length) {
            return root;
          }

          const tags = root.children.find(node => node.data && node.data.ref === "tags");
          const collapsed = tags && tags.children.find(node => node.tag === "span");
          if (!collapsed) return root;

          const limit = Number.isInteger(this.maxCollapseTags) && this.maxCollapseTags > 0
            ? this.maxCollapseTags
            : 2;
          const visible = this.selected.slice(0, limit);
          const remaining = this.selected.slice(limit);
          const tagProps = {
            size: this.collapseTagSize,
            type: "info",
            disableTransitions: true,
          };

          root.data.class = [root.data.class, "el-select--collapsed-tags"];
          collapsed.data = { ...collapsed.data, staticClass: "el-select__collapsed-tags" };
          collapsed.children = visible.map(item => createElement("el-tag", {
            key: `selected-${this.getValueKey(item)}`,
            staticClass: "el-select__collapsed-tag",
            attrs: { title: item.currentLabel },
            props: {
              ...tagProps,
              closable: !this.selectDisabled,
              hit: item.hitState,
            },
            on: { close: event => this.deleteTag(event, item) },
          }, [createElement("span", {
            staticClass: "el-select__tags-text",
          }, [item.currentLabel])]));

          if (remaining.length) {
            collapsed.children.push(createElement("el-tag", {
              key: "collapsed-summary",
              staticClass: "el-select__collapsed-summary",
              attrs: { title: remaining.map(item => item.currentLabel).join(", ") },
              props: { ...tagProps, closable: false },
            }, [createElement("span", {
              staticClass: "el-select__tags-text",
            }, [`+ ${remaining.length}`])]));
          }

          return root;
        };
      },
    });
  },
};
